<template>
  <span>
    <slot :name='"slot-" + oneFilterInfo.ColumnCode' :oneFilter='oneFilterInfo'>
      <span v-if='oneFilterInfo.OutDisplay === "1"'>
        <span v-if='oneFilterInfo.DataType === "0" && (oneFilterInfo.FilterType === "00" ||
            oneFilterInfo.FilterType === "01" || oneFilterInfo.FilterType === "10" ||
            oneFilterInfo.FilterType === "11" || oneFilterInfo.FilterType === "12" ||
            oneFilterInfo.FilterType === "13")'>
          <el-input v-model='oneFilterInfo.DefaultVal1' style='width: 125px;' :placeholder='oneFilterInfo.ColumnName'
            @keyup.enter.native='filter()' size='mini' class='filterInput' suffix-icon=''></el-input>
        </span>

        <span v-if='oneFilterInfo.DataType === "0" && (oneFilterInfo.FilterType === "14")'>
          <el-select v-model='oneFilterInfo.DefaultVal1' style='width: 125px;'
            :placeholder='oneFilterInfo.ColumnName + "是否为空"'
            size='mini' class='filterInput' @change='filter()'>
            <el-option v-for='isNull in isNulls' :key='isNull.code' :label='isNull.name' :value='isNull.code'>
            </el-option>
          </el-select>
        </span>

        <span v-if='(oneFilterInfo.DataType === "1" || oneFilterInfo.DataType === "2") &&
            (oneFilterInfo.FilterType === "00" ||
            oneFilterInfo.FilterType === "01" || oneFilterInfo.FilterType === "20" ||
            oneFilterInfo.FilterType === "21" || oneFilterInfo.FilterType === "22" ||
            oneFilterInfo.FilterType === "23")'>
          <el-input v-model='oneFilterInfo.DefaultVal1' style='width: 125px;' :placeholder='oneFilterInfo.ColumnName'
            @keyup.enter.native='filter()' size='mini' class='filterInput' @change='numberChange' suffix-icon=''></el-input>
        </span>

        <span v-if='(oneFilterInfo.DataType === "1" || oneFilterInfo.DataType === "2") &&
          (oneFilterInfo.FilterType === "14")'>
          <el-select v-model='oneFilterInfo.DefaultVal1' style='width: 125px;'
            :placeholder='oneFilterInfo.ColumnName + "是否为空"'
            size='mini' class='filterInput' @change='filter()'>
            <el-option v-for='isNull in isNulls' :key='isNull.code' :label='isNull.name' :value='isNull.code'>
            </el-option>
          </el-select>
        </span>

        <span v-if='oneFilterInfo.DataType === "3" && (oneFilterInfo.FilterType === "00" || oneFilterInfo.FilterType === "01")'>
          <el-select v-model='oneFilterInfo.DefaultVal1' style='width: 125px;' :placeholder='oneFilterInfo.ColumnName'
            @change='filter()' size='mini' class='filterInput'>
            <el-option v-for='bool in bools' :key='bool.code' :label='bool.name' :value='bool.code'>
            </el-option>
          </el-select>
        </span>

        <span v-if='oneFilterInfo.DataType === "3" && (oneFilterInfo.FilterType === "14")'>
        <el-select v-model='oneFilterInfo.DefaultVal1' style='width: 125px;'
          :placeholder='oneFilterInfo.ColumnName + "是否为空"'
          size='mini' class='filterInput' @change='filter()'>
          <el-option v-for='isNull in isNulls' :key='isNull.code' :label='isNull.name' :value='isNull.code'>
          </el-option>
        </el-select>
        </span>

        <span v-if='oneFilterInfo.DataType === "4" && (oneFilterInfo.FilterType === "00" ||
          oneFilterInfo.FilterType === "01")'>
          <el-date-picker v-if='oneFilterInfo.DateFormat.length === 4' type='year'
            v-model='oneFilterInfo.DefaultVal1' :format='oneFilterInfo.DateFormat' align='right'
            @change='filter()' :placeholder='oneFilterInfo.ColumnName' style='width: 125px;' size='mini' class='filterInput'>
          </el-date-picker>
          <el-date-picker v-if='oneFilterInfo.DateFormat.length === 7' type='month'
            v-model='oneFilterInfo.DefaultVal1' :format='oneFilterInfo.DateFormat' align='right'
            @change='filter()' :placeholder='oneFilterInfo.ColumnName' style='width: 125px;' size='mini' class='filterInput'>
          </el-date-picker>
          <el-date-picker v-if='oneFilterInfo.DateFormat.length === 10' type='date'
            v-model='oneFilterInfo.DefaultVal1' :format='oneFilterInfo.DateFormat' align='right'
            @change='filter()' :placeholder='oneFilterInfo.ColumnName' style='width: 125px;' size='mini' class='filterInput'>
          </el-date-picker>
          <el-date-picker v-if='oneFilterInfo.DateFormat.length > 10' type='datetime'
            v-model='oneFilterInfo.DefaultVal1' :format='oneFilterInfo.DateFormat' align='right'
            @change='filter()' :placeholder='oneFilterInfo.ColumnName' style='width: 125px;' size='mini' class='filterInput'>
          </el-date-picker>
        </span>

        <span v-if='oneFilterInfo.DataType === "4" && (oneFilterInfo.FilterType === "10" ||
          oneFilterInfo.FilterType === "11")'>
          <el-date-picker v-if='oneFilterInfo.DateFormat.length === 4' type='year'
            v-model='oneFilterInfo.DefaultVal1' :format='oneFilterInfo.DateFormat' align='right'
            @change='filter()' :placeholder='oneFilterInfo.ColumnName + "开始"' style='width: 125px;' size='mini' class='filterInput'>
          </el-date-picker>
          <el-date-picker v-if='oneFilterInfo.DateFormat.length === 7' type='month'
            v-model='oneFilterInfo.DefaultVal1' :format='oneFilterInfo.DateFormat' align='right'
            @change='filter()' :placeholder='oneFilterInfo.ColumnName + "开始"' style='width: 125px;' size='mini' class='filterInput'>
          </el-date-picker>
          <el-date-picker v-if='oneFilterInfo.DateFormat.length === 10' type='date'
            v-model='oneFilterInfo.DefaultVal1' :format='oneFilterInfo.DateFormat' align='right'
            @change='filter()' :placeholder='oneFilterInfo.ColumnName + "开始"' style='width: 125px;' size='mini' class='filterInput'>
          </el-date-picker>
          <el-date-picker v-if='oneFilterInfo.DateFormat.length > 10' type='datetime'
            v-model='oneFilterInfo.DefaultVal1' :format='oneFilterInfo.DateFormat' align='right'
            @change='filter()' :placeholder='oneFilterInfo.ColumnName + "开始"' style='width: 125px;' size='mini' class='filterInput'>
          </el-date-picker>
          <el-date-picker v-if='oneFilterInfo.DateFormat.length === 4' type='year'
            v-model='oneFilterInfo.DefaultVal2' :format='oneFilterInfo.DateFormat' align='right'
            @change='filter()' :placeholder='oneFilterInfo.ColumnName + "结束"' style='width: 125px;' size='mini' class='filterInput'>
          </el-date-picker>
          <el-date-picker v-if='oneFilterInfo.DateFormat.length === 7' type='month'
            v-model='oneFilterInfo.DefaultVal2' :format='oneFilterInfo.DateFormat' align='right'
            @change='filter()' :placeholder='oneFilterInfo.ColumnName + "结束"' style='width: 125px;' size='mini' class='filterInput'>
          </el-date-picker>
          <el-date-picker v-if='oneFilterInfo.DateFormat.length === 10' type='date'
            v-model='oneFilterInfo.DefaultVal2' :format='oneFilterInfo.DateFormat' align='right'
            @change='filter()' :placeholder='oneFilterInfo.ColumnName + "结束"' style='width: 125px;' size='mini' class='filterInput'>
          </el-date-picker>
          <el-date-picker v-if='oneFilterInfo.DateFormat.length > 10' type='datetime'
            v-model='oneFilterInfo.DefaultVal2' :format='oneFilterInfo.DateFormat' align='right'
            @change='filter()' :placeholder='oneFilterInfo.ColumnName + "结束"' style='width: 125px;' size='mini' class='filterInput'>
          </el-date-picker>
        </span>

        <span v-if='oneFilterInfo.DataType === "4" && (oneFilterInfo.FilterType === "14")'>
          <el-select v-model='oneFilterInfo.DefaultVal1' style='width: 125px;'
            :placeholder='oneFilterInfo.ColumnName + "是否为空"'
            size='mini' class='filterInput' @change='filter()'>
            <el-option v-for='isNull in isNulls' :key='isNull.code' :label='isNull.name' :value='isNull.code'>
            </el-option>
          </el-select>
        </span>

        <span v-if='oneFilterInfo.DataType === "5" && (oneFilterInfo.FilterType === "00" ||
          oneFilterInfo.FilterType === "01")'>
          <el-select v-model='oneFilterInfo.DefaultVal1' style='width: 125px;'
            @change='filter()' :placeholder='oneFilterInfo.ColumnName ' size='mini' class='filterInput'>
            <el-option v-for='specialStr in getSpecialStringArrayInner(oneFilterInfo.ColumnCode)' :key='specialStr.code' :label='specialStr.name' :value='specialStr.code'>
            </el-option>
          </el-select>
        </span>

        <span v-if='oneFilterInfo.DataType === "5" && (oneFilterInfo.FilterType === "10" ||
          oneFilterInfo.FilterType === "11")'>
          <el-select v-model='oneFilterInfo.DefaultVal1' multiple collapse-tags style='width: 200px;'
            @change='filter()' :placeholder='oneFilterInfo.ColumnName ' size='mini' class='filterInput'>
            <el-option v-for='specialStr in getSpecialStringArrayInner(oneFilterInfo.ColumnCode)' :key='specialStr.code' :label='specialStr.name' :value='specialStr.code'>
            </el-option>
          </el-select>
        </span>

        <span v-if='oneFilterInfo.DataType === "5" && (oneFilterInfo.FilterType === "14")'>
        <el-select v-model='oneFilterInfo.DefaultVal1' style='width: 125px;'
          :placeholder='oneFilterInfo.ColumnName + "是否为空"'
          size='mini' class='filterInput' @change='filter()'>
          <el-option v-for='isNull in isNulls' :key='isNull.code' :label='isNull.name' :value='isNull.code'>
          </el-option>
        </el-select>
        </span>
      </span>
    </slot>
  </span>
</template>

<script>
import code from '@/components/sys/Code'

export default {
  name: 'TableFilterOutDisplay',
  props: {
    oneFilterInfo: {
      default: function () {
        return {}
      },
      type: Object
    },
    getSpecialStringArray: {
      default: function () {
        return []
      },
      type: Function
    },
    columnInfo: {
      default: function () {
        return []
      },
      type: Array
    }
  },

  data: function () {
    return {
      bools: [{ code: 1, name: '是' }, { code: 0, name: '否' }],
      isNulls: [{ code: '1', name: '是' }, { code: '0', name: '否' }]
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  methods: {
    filter: function () {
      this.$emit('filter')
    },

    getSpecialStringArrayInner: function (columnCode) {
      const that = this
      const arys = that.getSpecialStringArray(columnCode)
      if (arys && arys.length > 0) {
        return arys
      } else {
        for (let i = 0; i < that.columnInfo.length; i++) {
          if (that.columnInfo[i].ColumnCode === columnCode) {
            return code.getCode(that.codes, that.columnInfo[i].DateFormat)
          }
        }
      }
    },

    numberChange: function (obj, code) {
      if (obj[code] === '') {
        return
      }
      try {
        obj[code] = parseFloat(obj[code])
        if (isNaN(obj[code])) {
          obj[code] = 0
        }
      } catch (err) {
        obj[code] = 0
      }
    }
  }
}
</script>

<style scoped>
.filterInput{
  margin-right: 10px;
  margin-top: 6px;
}
</style>
